if (!window.VKBindCodProxyButtons) {
  window.VKNormalizeBuyNowButtons = () => {
    document.querySelectorAll('#rsi_buy_now_button').forEach((button) => {
      button.setAttribute('data-qk-releasit-native', 'true');
    });
  };

  window.VKFindReleasitButton = async () => {
    const findButton = () => {
      const buttons = Array.from(document.querySelectorAll('#rsi_buy_now_button')).filter(
        (button) => !button.matches('[data-qk-sticky-cod-proxy]')
      );

      return (
        buttons.find((button) => button.closest('.section-main-product .main-product-form')) ||
        buttons.find((button) => button.closest('.section-main-product')) ||
        buttons[0] ||
        null
      );
    };

    let releasitButton = findButton();
    if (releasitButton) return releasitButton;

    for (let index = 0; index < 20; index += 1) {
      await new Promise((resolve) => setTimeout(resolve, 150));
      releasitButton = findButton();
      if (releasitButton) return releasitButton;
    }

    return null;
  };

  window.VKBindCodProxyButtons = () => {
    window.VKNormalizeBuyNowButtons();

    document.querySelectorAll('[data-qk-sticky-cod-proxy]').forEach((proxyButton) => {
      if (proxyButton.dataset.vkProxyBound === 'true') return;

      proxyButton.dataset.vkProxyBound = 'true';
      proxyButton.addEventListener('click', async (event) => {
        event.preventDefault();

        const releasitButton = await window.VKFindReleasitButton();

        if (releasitButton) {
          releasitButton.click();
          return;
        }

        proxyButton.classList.remove('btn--loading');
        proxyButton.removeAttribute('aria-disabled');
        proxyButton.dispatchEvent(
          new CustomEvent('quirkup:cod-form-unavailable', {
            bubbles: true,
            detail: { source: 'releasit' },
          })
        );
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.VKBindCodProxyButtons, { once: true });
  } else {
    window.VKBindCodProxyButtons();
  }

  new MutationObserver(() => {
    window.VKNormalizeBuyNowButtons();
    window.VKBindCodProxyButtons();
  }).observe(document.documentElement, { childList: true, subtree: true });
}

if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      constructor() {
        super();
        document.body.classList.add('sticky-atc-bar-enabled');
      }

      get variantIdSelect() {
        return this.querySelector('[name="id"]');
      }

      connectedCallback() {
        this.productFormActions = document.querySelector('.main-product-form');
        this.mainProductInfo = document.querySelector('product-info');
        this.container = this.closest('.sticky-atc-bar');

        this.variantData = this.getVariantData();
        this.select = this.querySelector('select');

        this.init();
        this.select.addEventListener('change', () => {
          if (this.isUpdating) return;
          this.isUpdating = true;

          this.mainVariantSelects = this.mainProductInfo && this.mainProductInfo.querySelector('variant-selects');
          const selectedVariantId = this.variantIdSelect.value;
          this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));

          if (this.mainVariantSelects) {
            Array.from(this.mainVariantSelects.querySelectorAll('select, fieldset'), (element, index) => {
              const variantOptionVal = this.currentVariant.options[index];
              switch (element.tagName) {
                case 'SELECT':
                  element.value = variantOptionVal;
                  const options = element.querySelectorAll('option');
                  options.forEach((option) => option.removeAttribute('selected'));

                  element.value = variantOptionVal;
                  const selectedOption = element.querySelector(`option[value="${variantOptionVal}"]`);
                  if (selectedOption) {
                    selectedOption.setAttribute('selected', 'selected');
                  }
                  break;
                case 'FIELDSET':
                  Array.from(element.querySelectorAll('input')).forEach((radio) => {
                    if (radio.value === variantOptionVal) {
                      radio.checked = true;
                    }
                  });
                  break;
              }
            });
            setTimeout(() => {
              this.mainVariantSelects.dispatchEvent(new Event('change', { detail: { formStickty: true } }));
              this.isUpdating = false;
            }, 0);
          } else {
            this.isUpdating = false;
          }

          this.updatePrice();
          this.updateButton(true, '', false);
          if (!this.currentVariant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!this.currentVariant.available, VKTheme.variantStrings.soldOut);
          }
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }

      init() {
        if (!this.productFormActions) {
          this.container.classList.remove('sticky-atc-bar--show');
          return;
        }
        this.productId = this.dataset.productId;

        const mql = window.matchMedia(VKTheme.config.mediaQueryMobile);
        mql.onchange = this.checkDevice.bind(this);
        this.checkDevice();

        this.purchaseTarget =
          this.productFormActions.querySelector(':scope > .product-form__buttons') ||
          this.productFormActions.querySelector('.product-form__buttons') ||
          this.productFormActions;
        this.updateStickyVisibility = this.updateStickyVisibility.bind(this);
        this.handleStickyVisibilityChange = () => {
          window.requestAnimationFrame(this.updateStickyVisibility);
        };
        this.handleStickyVisibilityChange();
        window.addEventListener('scroll', this.handleStickyVisibilityChange, { passive: true });
        window.addEventListener('resize', this.handleStickyVisibilityChange);
        this.syncWithMainProductForm();
        this.bindStickyCodProxy();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleStickyVisibilityChange);
        window.removeEventListener('resize', this.handleStickyVisibilityChange);
      }

      updateStickyVisibility() {
        if (!this.purchaseTarget || !this.container) return;

        const rect = this.purchaseTarget.getBoundingClientRect();
        const stickyHeight = this.container.offsetHeight || 84;
        const headerOffset = Math.max(
          0,
          document.querySelector('sticky-header, .shopify-section-header')?.getBoundingClientRect().bottom || 0
        );
        const visibleTop = headerOffset + 8;
        const visibleBottom = window.innerHeight - stickyHeight - 12;
        const purchaseControlsVisible = rect.bottom > visibleTop && rect.top < visibleBottom;
        const customerHasScrolled = window.scrollY > Math.min(140, window.innerHeight * 0.18);
        const hideSticky = purchaseControlsVisible || !customerHasScrolled;

        this.container.classList.toggle('sticky-atc-bar--show', !hideSticky);
        this.container.toggleAttribute('inert', hideSticky);
        this.container.setAttribute('aria-hidden', hideSticky ? 'true' : 'false');
      }

      checkDevice() {
        document.documentElement.style.setProperty('--sticky-atc-bar-height', this.clientHeight + 'px');
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.sticky-atc-bar__form');
        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');
        const codButton = productForm.querySelector('[data-qk-sticky-cod-proxy]');
        if (!addButton) return;

        const addButtonText = addButton.querySelector('span');
        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (codButton) codButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (codButton) codButton.removeAttribute('disabled');
          addButtonText.textContent = VKTheme.variantStrings.addToCart;
        }
      }

      bindStickyCodProxy() {
        window.VKBindCodProxyButtons?.();
      }

      updatePrice() {
        const classes = {
          onSale: 'f-price--on-sale',
          soldOut: 'f-price--sold-out',
        };
        const selectors = {
          priceWrapper: '.f-price',
          salePrice: '.f-price-item--sale',
          compareAtPrice: ['.f-price-item--regular'],
          unitPriceWrapper: '.f-price__unit-wrapper',
        };
        const moneyFormat = VKTheme.settings.moneyFormat;
        const { priceWrapper, salePrice, unitPriceWrapper, compareAtPrice } = VKTheme.utils.queryDomNodes(
          selectors,
          this
        );
        const unitPrice = unitPriceWrapper.querySelector('.f-price__unit');

        const { compare_at_price, price, unit_price_measurement } = this.currentVariant;

        // On sale.
        if (compare_at_price && compare_at_price > price) {
          priceWrapper.classList.add(classes.onSale);
        } else {
          priceWrapper.classList.remove(classes.onSale);
        }

        // Sold out.
        if (!this.currentVariant.available) {
          priceWrapper.classList.add(classes.soldOut);
        } else {
          priceWrapper.classList.remove(classes.soldOut);
        }

        if (salePrice) salePrice.innerHTML = VKTheme.Currency.formatMoney(price, moneyFormat);

        if (compareAtPrice && compareAtPrice.length && compare_at_price > price) {
          compareAtPrice.forEach(
            (item) => (item.innerHTML = `<s>${VKTheme.Currency.formatMoney(compare_at_price, moneyFormat)}</s>`)
          );
        } else {
          compareAtPrice.forEach((item) => (item.innerHTML = VKTheme.Currency.formatMoney(price, moneyFormat)));
        }

        if (unit_price_measurement && unitPrice) {
          unitPriceWrapper.classList.remove('hidden');
          const unitPriceContent = `<span>${VKTheme.Currency.formatMoney(
            this.currentVariant.unit_price,
            moneyFormat
          )}</span>/<span data-unit-price-base-unit>${this._getBaseUnit()}</span>`;
          unitPrice.innerHTML = unitPriceContent;
        } else {
          unitPriceWrapper.classList.add('hidden');
        }
      }

      syncWithMainProductForm() {
        VKTheme.pubsub.subscribe(VKTheme.pubsub.PUB_SUB_EVENTS.variantChange, (event) => {
          const isMainProduct = event.data.sectionId === this.mainProductInfo.dataset.section;
          if (!isMainProduct) return;
          const variant = event.data.variant;
          const variantInput = this.querySelector('[name="id"]');

          this.currentVariant = variant;
          variantInput.value = variant.id;
          this.updatePrice();
          this.updateButton(true, '', false);
          if (!variant) {
            this.updateButton(true, '', true);
          } else {
            this.updateButton(!variant.available, VKTheme.variantStrings.soldOut);
          }
        });
      }
    }
  );
}
